<template>
    <el-dropdown @command="onClickItem">
        <el-button type="default" plain size="mini">
            <i class="iconfont icon-language"></i>
            <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(label, key) in languages" :command="key" :key="key">{{ label }}</el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
    import { mapActions } from 'vuex';
    import eventBus from '../utils/eventBus';

    export default {
        name: 'Localization',

        data() {
            return {
                languages: {
                    en: 'English',
                    zh: '中文',
                    th: 'ไทย',
                    ko: '한국어',
                    'zh-TW': '中文繁體',
                },
            };
        },

        methods: {
            ...mapActions('lang', ['setLang']),
            ...mapActions('setting', ['setDefaultAreaUnitByLang']),

            onClickItem(command) {
                this.$i18n.locale = command;
                this.setLang(command);
                this.setDefaultAreaUnitByLang(command);
                eventBus.$emit('switch-element-ui-lang', command);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .iconfont {
        font-size: 20px;
        line-height: .5;
    }
</style>
